export const EXPERTISE_ROUTES = {
  expertiseForm               : 'formulario/abuso/sexual',
  historyPatientExpertise     : 'historial/paciente/abuso/sexual',
  historyProfessionalExpertise: 'historial/profesional',

};
